export const COLORS = {
  darkModeBg: "#010219",
  white: "#FFFFFF",
  black: "#000000",
  grey: "#262636",
  lightGrey: "#D9D9D9",
  // green: "#1D8C23",
  green: "#b9a428",
  darkGrey: "#2D3748",
  lightBrown: "#DCDCDC",
  chartbg: "#242438",
  // lightGreen: "#E4F3E5",
  lightGreen: "#c7b94e",

  //AAHERA COLOrs(LIGHT MODE)
  primary: "#b9a428",
  primaryDark: "#655c16",

  // primary: "#1D8C23",
  // primaryDark: "#1D8C23",
  primaryLight: "#c7b94e",
  secondary: "#FC7067",
  bgGrey: "#F7F7F7",
  bgColor: "#b9a428",
  bgColorLight: "#F9F9F9",
  lightPink: "#FEE8E7",
};
